// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// `window.fetch` polyfill.
import 'whatwg-fetch';

import Rails from '@rails/ujs';
import * as ActiveStorage from '@rails/activestorage';
import $ from 'jquery';
import { Modal } from 'bootstrap';

import 'channels';
import 'css/esites';
import 'src/esites/calendar/index';

$(() => {
  new Modal(document.getElementById('modal'), {});
});

Rails.start()
ActiveStorage.start()
